module.exports = __webpack_public_path__ + "static/media/acepta_pie.dfea69d4.svg";